import React from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaTwitter, FaPinterest, FaLinkedin, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        {/* Contact Section */}
        <div style={styles.section}>
          <h3 style={styles.heading}>Contact Us</h3>
          <div style={styles.contactItem}>
            <FaMapMarkerAlt style={styles.iconWhite} />
            <p>Yorktown Heights, NY</p>
          </div>
          <div style={styles.contactItem}>
            <FaPhoneAlt style={styles.iconWhite} />
            <p>+1 (914) 962-8444</p>
          </div>
          <div style={styles.contactItem}>
            <FaEnvelope style={styles.iconWhite} />
            <p>jetblacklimo@aol.com</p>
          </div>

          <div style={styles.socialIcons}>
            <FaFacebookF style={styles.socialIcon} />
            <FaTwitter style={styles.socialIcon} />
            <FaPinterest style={styles.socialIcon} />
            <FaLinkedin style={styles.socialIcon} />
            <FaInstagram style={styles.socialIcon} />
          </div>
        </div>

        {/* Home & Policies Section */}
        <div style={styles.section}>
          <h3 style={styles.heading}>Information</h3>
          <ul style={styles.list}>
            <li><span style={styles.link}>Home</span></li>
            <li><span style={styles.link}>Fleet</span></li>
            <li><span style={styles.link}>Reservations</span></li>
            <li><span style={styles.link}>FAQs</span></li>
            <li><span style={styles.link}>Services</span></li>
            <li><span style={styles.link}>Contact</span></li>
            <li><span style={styles.link}>Privacy Policy</span></li>
            <li><span style={styles.link}>Refund Policy</span></li>
            <li><span style={styles.link}>Terms and Conditions</span></li>
            <li><span style={styles.link}>Blog</span></li>
          </ul>
        </div>

        {/* Services Section */}
        <div style={styles.section}>
          <h3 style={styles.heading}>Our Services</h3>
          <ul style={styles.list}>
            <li><span style={styles.link}>Wedding Luxury Car Service</span></li>
            <li><span style={styles.link}>Corporate Transfer Service</span></li>
            <li><span style={styles.link}>Point to Point Transfer Service</span></li>
            <li><span style={styles.link}>Prom Car Service</span></li>
            <li><span style={styles.link}>Airport Transfer Service</span></li>
            <li><span style={styles.link}>Private Transfer Service</span></li>
            <li><span style={styles.link}>Night Tour Car Service</span></li>
            <li><span style={styles.link}>Party Car Service</span></li>
            <li><span style={styles.link}>Car & Chauffeur Service</span></li>
          </ul>
        </div>

        {/* Airport Transfers Section */}
        <div style={styles.section}>
          <h3 style={styles.heading}>Airport Transfers</h3>
          <ul style={styles.list}>
            <li><span style={styles.link}>John F. Kennedy (JFK) Airport</span></li>
            <li><span style={styles.link}>LaGuardia (LGA) Airport</span></li>
            <li><span style={styles.link}>Newark (EWR) Airport</span></li>
            <li><span style={styles.link}>Westchester County (HPN) Airport</span></li>
            <li><span style={styles.link}>Bradley Airport</span></li>
            <li><span style={styles.link}>New York City</span></li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: '#0d2b3e',
    color: '#ffffff',
    padding: '40px 20px',
    width: '100%',
    fontFamily: '"Merriweather", serif',
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap', // Para que sea responsivo en móviles
    maxWidth: '1200px',
    margin: '0 auto',
  },
  section: {
    flex: '1 1 calc(25% - 20px)', // Cuatro secciones iguales
    minWidth: '200px',
    padding: '10px',
  },
  heading: {
    borderBottom: '2px solid #ffffff',
    paddingBottom: '5px',
    marginBottom: '15px',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  contactItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '8px',
  },
  iconWhite: {
    color: '#ffffff',
    fontSize: '20px',
  },
  socialIcons: {
    display: 'flex',
    gap: '10px',
    marginTop: '10px',
  },
  socialIcon: {
    fontSize: '24px',
    color: '#ffffff',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
  },
  list: {
    listStyle: 'none',
    padding: '0',
  },
  link: {
    color: '#ffffff',
    textDecoration: 'none',
    fontSize: '16px',
    padding: '5px 0',
    display: 'block',
    fontWeight: '500',
    transition: 'color 0.3s ease',
  },
  verticalDivider: {
    backgroundColor: '#ffffff',
    opacity: 0.3,
    width: '2px',
    height: 'auto',
    margin: '0 10px',
    borderRadius: '5px',
  },
};

export default Footer;
